import React, { useEffect, useRef, useState } from 'react';
import Classes from './BrandPage.module.css';
import { useNavigate } from 'react-router-dom';

const imageLoadQueue = [];

export default function ProductItem({ product, index }) {
  const navigateTo = useNavigate();
  const [isLoaded, setIsLoaded] = useState(false);
  const imgRef = useRef();

  useEffect(() => {
    const loader = new Promise((resolve) => {
      const img = new Image();
      img.src = product.images[0];
      img.onload = () => resolve(true);
    });

    const lastInQueue = imageLoadQueue[imageLoadQueue.length - 1] || Promise.resolve();
    const current = lastInQueue.then(() => loader).then(() => {
      setIsLoaded(true);
    });

    imageLoadQueue.push(current);
  }, [product.images]);

  return (
    <div className={Classes.card}>
      {!isLoaded ? (
        <img
          src="/images/placeholder.png"
          alt="placeholder"
          className={Classes.productImage}
          draggable={false}
        />
      ) : (
        <img
          ref={imgRef}
          src={product?.images[0]}
          alt={product?.title}
          rel="noopener noreferrer"
          className={Classes.productImage}
          draggable={false}
          onClick={() => navigateTo(`/product/${product.id}`)}
        />
      )}
      <h5 className={Classes.title1}>{product.title}</h5>
      <h5 className={Classes.title2}>{product.subTitle}</h5>
      <h5 className={Classes.text2}>
        {product?.images?.length} Color{product?.images?.length !== 1 ? 's' : ''}
      </h5>
      <div className='flexAlign5' >
        <h5 className={Classes.price}>AED {product?.price}</h5>
        <h5 className={Classes.originalPrice}>{product?.originalPrice}</h5>
      </div>
    </div>
  );
}
